var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-row",
    [
      _c("vs-col", { attrs: { "vs-w": "12" } }, [
        _c("h3", [_vm._v(" Mantenedor de adjuntos para flujos ")]),
        _c("h5", { staticClass: "mb-5" }, [
          _vm._v(
            " Estas opciones activas aparecerán en los formularios de la aplicación. "
          )
        ])
      ]),
      _c(
        "vs-col",
        {
          staticClass: "mt-5",
          attrs: { "vs-lg": "12", id: "listado-opciones" }
        },
        [
          _c(
            "vs-row",
            {
              attrs: {
                "vs-type": "flex",
                "vs-align": "space-around",
                "vs-justify": "space-around"
              }
            },
            [
              _c(
                "vs-col",
                { staticClass: "mt-3", attrs: { "vs-sm": "12", "vs-lg": "6" } },
                [
                  _c(
                    "div",
                    { staticClass: "add-new" },
                    [
                      _c("h4", [_vm._v("Tipos de adjuntos")]),
                      _c(
                        "CheckPermission",
                        { attrs: { permission: "*" } },
                        [
                          _c("vs-button", {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: "Agregar tipo de adjunto",
                                expression: "'Agregar tipo de adjunto'"
                              }
                            ],
                            staticClass: "margin-right",
                            attrs: {
                              color: "primary",
                              type: "border",
                              icon: "playlist_add"
                            },
                            on: {
                              click: function($event) {
                                _vm.createMood = !_vm.createMood
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "vs-list",
                    { staticClass: "bg-white mt-3 box-options" },
                    _vm._l(_vm.typeAttachments, function(type) {
                      return _c(
                        "div",
                        { key: type.opcionId, staticClass: "wrap-list-item" },
                        [
                          _c("ListItemOptionAttachmentType", {
                            attrs: {
                              option: type,
                              type: "category",
                              selectedCategory:
                                _vm.selectedTypeAttachment &&
                                _vm.selectedTypeAttachment.opcionId ===
                                  type.opcionId
                            }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            title: "Nuevo tipo de adjunto",
            "no-close-on-backdrop": "",
            centered: "",
            "hide-footer": ""
          },
          model: {
            value: _vm.createMood,
            callback: function($$v) {
              _vm.createMood = $$v
            },
            expression: "createMood"
          }
        },
        [
          _c("div", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.option.valor,
                  expression: "option.valor"
                }
              ],
              staticClass: "input-option input-edit",
              attrs: {
                maxlength: "10",
                placeholder: "Abreviación",
                size: "small"
              },
              domProps: { value: _vm.option.valor },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.option, "valor", $event.target.value)
                }
              }
            })
          ]),
          _c("div", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.option.descripcion,
                  expression: "option.descripcion"
                }
              ],
              staticClass: "input-option input-edit",
              attrs: {
                maxlength: "100",
                placeholder: "Nombre de opción",
                size: "small"
              },
              domProps: { value: _vm.option.descripcion },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.option, "descripcion", $event.target.value)
                }
              }
            })
          ]),
          _c(
            "div",
            { staticClass: "d-flex justify-content-center" },
            [
              _c(
                "vs-button",
                {
                  staticClass: "mt-3",
                  attrs: { color: "primary", type: "border", icon: "save" },
                  on: {
                    click: function($event) {
                      return _vm.saveOption()
                    }
                  }
                },
                [_vm._v(" Guardar ")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }